export default __webpack_public_path__ + "static/media/CSIC_LOGO.be99ee84.jpeg";